export { default } from './InformationPopup';
